// extracted by mini-css-extract-plugin
export default {"quantityLabel":"styles_quantityLabel__uViCT","iconTooltip":"styles_iconTooltip__PcWwK"};